import React from 'react';
import './Timesheet.css';

const timesheet = ( props ) => (
	<section id="Timesheet">
		<h2>Timesheet <span>Tutorial</span></h2>
		<iframe title="Timesheet Video Tutorial" src="https://www.youtube.com/embed/SL4ZcE-5QG0" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
	</section>
);

export default timesheet;



// WEBPACK FOOTER //
// ./src/pages/Pay/Timesheet/Timesheet.js